import React from 'react'
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';

const TableCellNoBorders = withStyles({
  root: {
    borderBottom: "none"
  }
})(TableCell);

export default function TicketActivityRow({row, i}) {
    return (
        <TableRow key={i}>
            <TableCellNoBorders align='right' component='th' scope='row'> { row.dateCreated } </TableCellNoBorders>
            <TableCellNoBorders align='left'> { row.customerName } </TableCellNoBorders>
            <TableCellNoBorders align='left'> {row.assignedEmployeeName} </TableCellNoBorders>
            <TableCellNoBorders align='left'> { row.active } </TableCellNoBorders>
        </TableRow>
    );
}



// WEBPACK FOOTER //
// ./src/component/TicketActivity/TicketActivityRow.js